import React from 'react';
import { Navigate } from 'react-router-dom';
import { isPublicRouteEdition } from '../../constants/psaRouteEdition';
import AppRouteNotFound from './AppRouteNotFound';

/**
 * Legacy redirect that must not reveal deferred targets in the public edition.
 *
 * @param {{ to: string }} props
 */
const DeferredRouteRedirect = ({ to }) => {
    if (isPublicRouteEdition()) {
        return <AppRouteNotFound />;
    }
    return <Navigate to={to} replace />;
};

export default DeferredRouteRedirect;
